/* eslint-disable dot-notation */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { scrollToElement } from 'core/utils/helpers/scrollToElement';
import {
  selectProductSearchResultMetadata, selectProductSearchResultInitialFacets,
} from 'core/modules/ProductSearchResults/selectors';
import { triggerPsrClearFilterGaEvent } from 'core/modules/ProductSearchResults/actions';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SortMobile from './components/SortMobile';
import FilterMobile from './components/FilterMobile';
import FilterPromotionsMobile from './components/FilterPromotionsMobile';

import { productSearchResultsConfig as config } from '../../configs';

import './MenuMobile.scss';

function MenuMobile({ filterHook, hideOverlay, productResultsHook }) {
  const dispatch = useDispatch();
  const { total } = useSelector(selectProductSearchResultMetadata);
  const initialFacets = useSelector(selectProductSearchResultInitialFacets);
  const { categoriesFilterTitle } = config;

  const { clearIdsInFilter } = filterHook;

  const onClearFilterClick = () => {
    scrollToElement(document.body, 0);
    clearIdsInFilter();
    dispatch(triggerPsrClearFilterGaEvent());
  };

  return (
    <div className="mn_psrMenuMobile">
      <h3 className="mn_menuTitle">Sort and filter your products</h3>
      <SortMobile productResultsHook={productResultsHook} />
      <FilterMobile facet={initialFacets['merchants']} filterHook={filterHook} title="Stores" />
      <FilterMobile facet={initialFacets['categories']} filterHook={filterHook} title={categoriesFilterTitle} />
      <FilterMobile facet={initialFacets['brands']} filterHook={filterHook} />
      <FilterPromotionsMobile filterHook={filterHook} />
      <FilterMobile facet={initialFacets['price']} filterHook={filterHook} />

      <div className="mn_buttonsWrap">
        <button className="mn_clearFilterButton" onClick={onClearFilterClick}>Clear all</button>
        <button className="mn_button mn_viewResultsButton" onClick={hideOverlay}>
          View {total} result{total === 1 ? '' : 's' }
        </button>
      </div>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><MenuMobile {...props} /></ComponentErrorBoundary>;
